import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { amberChipClass } from '../contactDisplay'
import { BADGE_TONE, badgeText } from './format'
import type { Agreement } from './types'

const TONE_CLASS = {
  danger: 'border-destructive/40 text-destructive',
  warning: amberChipClass,
  success: 'border-border text-foreground',
  neutral: 'border-border text-muted-foreground',
} as const

/** The state of an agreement as a chip with text (design §4.6; never colour alone, IA-20). */
export function AgreementStatusBadge({ agreement }: { agreement: Agreement }) {
  if (!agreement.badge) return null
  return (
    <Badge variant="outline" className={cn('shrink-0', TONE_CLASS[BADGE_TONE[agreement.badge]])}>
      {agreement.badge === 'achterstallig' ? '! ' : ''}
      {badgeText(agreement)}
    </Badge>
  )
}
